import { Close } from "@material-ui/icons";
import yaml from 'js-yaml';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { CardColumn, CloseButton, Container, FormContent, Header, HeaderTitle, InfoSectionTitle } from './styles';
  
interface IShowAuditLogDetailProps {
    setModalStatus: (status: boolean) => void;
    oldInfo?: string;
    currentInfo?: string;
};

const ShowAuditLogDetail: React.FC<IShowAuditLogDetailProps> = ({
  setModalStatus,
  currentInfo,
  oldInfo,
}) => {
    const { t } = useTranslation();

    return (
        <Container>
            <Header>
                <HeaderTitle>
                    {`${t("softwareManagement.modules.audit.showInfo.details")}`}
                </HeaderTitle>

                <CloseButton onClick={() => setModalStatus(false)}>
                    <Close />
                </CloseButton>
            </Header>

            <FormContent>            
                <CardColumn>
                    <InfoSectionTitle>
                        {`${t("softwareManagement.modules.audit.showInfo.oldInfo")}`}
                    </InfoSectionTitle>

                    <pre id="yaml-output">
                        {oldInfo ? yaml.dump(JSON.parse(oldInfo || ''), {
                            noRefs: true
                        }) : ''}
                    </pre>                   
                </CardColumn>

                <CardColumn>
                    <InfoSectionTitle>
                        {`${t("softwareManagement.modules.audit.showInfo.currentInfo")}`}
                    </InfoSectionTitle>
                        
                    <pre id="yaml-output">
                        {currentInfo ? yaml.dump(JSON.parse(currentInfo || ''), {
                            noRefs: true
                        }) : ''}
                    </pre>
                </CardColumn>
            </FormContent>
            <script src="https://cdnjs.cloudflare.com/ajax/libs/js-yaml/4.1.0/js-yaml.min.js"></script>

        </Container>
    )
}

export default ShowAuditLogDetail;